<template>
    <div class="row justify-content-center">
        <div class="col-sm-12 col-md-8 mb-2">
            <div class="inputype Keywords-input">
                <form>
                    <!-- <h4 class="interiorTitle">Titulo</h4> -->
                    <input type="text " v-model="keyword" placeholder="ej. Mi Keyword" />
                </form>
            </div>
        </div>
        <div class="col-sm-12 col-md-4 mb-2">
            <div class="Keywords-button-container">
                <button :class="[
                    'button',
                    'fluid',
                    'alternative',
                    'noMargin',
                    keyword ? '' : 'disabled'
                ]" @click="() => addKeywords()" :disabled="keyword == ''">
                    Agregar
                </button>
            </div>
        </div>
        <div class="col-12">
            <div class="chip-button">
                <div class="chip primary iconed" v-for="(item, index) in keywords" v-bind:key="index">
                    {{ item }}
                    <button class="icon" @click="() => removeKeyword(index)">
                        <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="feather feather-x">
                            <line x1="16" y1="8" x2="8" y2="16" />
                            <line x1="8" y1="8" x2="16" y2="16" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- </div>
    </div> -->
</template>
<script>
export default {
    props: ['addKeyword', 'keywords', 'removeKeyword'],
    data() {
        return {
            keyword:""
        }
    },
    methods: {
        async addKeywords(){
            await this.addKeyword(this.keyword);
            this.keyword = "";
        }
    }
}
</script>